import { SvgIcon } from '@mui/material';
import React from 'react';

export default function RemoveIcon({ ...props }) {
  return (
    <SvgIcon
      height="3"
      viewBox="0 0 20 3"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        height="2.02541"
        rx="1.0127"
        width="19.5789"
        x="0.0268555"
        y="0.0507812"
      />
    </SvgIcon>
  );
}
